import React, { Component } from "react";

// eslint-disable-next-line import/no-anonymous-default-export
export default class extends Component {

  constructor(props) {
    super(props);
    this.state = {
      propData: '',
      propName: '',
    }
    this.onChangeValue = this.onChangeValue.bind(this);
  }
  componentDidMount() {

    //this.setState({ propData, propName })

  }

  onChangeValue(event) {
    let data = this.props.data;
    data[this.props.column.colId] = event.target.value;
    if (this.props.onChange && typeof this.props.onChange === 'function') {
      this.props.onChange(data)
    };
    this.setState({ propData: event.target.value })
  }

  render() {
    let { colId } = this.props.column;
    let { nameProp, radioValues } = this.props;
    let propData = this.props.data[colId];
    let propName = this.props.data[nameProp];
    return (
      <>
        <div onChange={this.onChangeValue.bind(this)}>
          {radioValues.map(rv => {
            return <span style={{ 'marginRight': '10px' }}><input type="radio" value={rv.val} name={propName} checked={propData === rv.val} /> {rv.label} </span>
          })}
        </div>
      </>
    );
  }
}
/* 

          <span style={{ 'marginRight': '10px' }}><input type="radio" value="Once" name={this.state.PropsID} checked={this.state.dataD === "Once"} /> Once </span>
          <span style={{ 'marginRight': '10px' }}><input type="radio" value="Annual" name={this.state.PropsID} checked={this.state.dataD === "Annual"} /> Year-End </span> */